module.exports = __webpack_public_path__ + "img/2ACDC02F-E8B0-4698-95D7-61680499FEED_1_201_a-min.100887d7.jpeg";